import { useCallback, useState } from "react";

export type ModalState<T> = [T, IModalActions<T>];
export interface IModalActions<T> {
  close: () => void;
  show: (value: T) => void;
}

export default function useModal<T>(defaultValue: T, hideValue = defaultValue): ModalState<T> {
  const [modalState, setModalState] = useState(defaultValue);

  return [
    modalState,
    {
      show: useCallback(
        (value: T) => {
          setModalState(value);
        },
        [setModalState]
      ),
      close: useCallback(() => {
        setModalState(hideValue);
      }, [hideValue]),
    },
  ];
}
